export const publicApiHostName = async (env) => {
	switch (env) {
		case "dev": {
			// for local testing - need to add this url to connect-src options as well
			return "http://localhost:8888";
		}
		case "staging": {
			return "https://staging.talent.performyard.com";
		}
		case "sandbox": {
			return "https://sandbox.talent.performyard.com";
		}
		case "production": {
			return "https://talent.performyard.com";
		}
	}
};
